import { QueryResult, QueryConfig } from "@/shared/types/base";
import { DocumentoElectronico } from "@/shared/types/documento-electronico";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";

export async function getDE(id: string): Promise<DocumentoElectronico> {
    const response = await api.get(`de/${id}`);
    return response.data;
}

export function useGetDEQuery(id: string, queryConfig: QueryConfig<DocumentoElectronico> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getDE(id),
        queryKey: ["de", id],
        enabled: !!id,
    });
}

export interface GetDEQueryProps {
    id: string,
    queryConfig?: QueryConfig<DocumentoElectronico>,
    children?: (queryResult: QueryResult<DocumentoElectronico>) => ReactNode
}

export function GetDEQuery({
    id,
    children,
    queryConfig
}: GetDEQueryProps) {
    const queryResult = useGetDEQuery(id, queryConfig);
    return children && children(queryResult);
}
